export const OriginMouseLayerEventList = [
    // 鼠标事件
    // 单击事件
    'click',
    'dblclick',
    'unclick',
    'undblclick',
    // 右键事件
    'contextmenu',
    'uncontextmenu',
    // mouse 事件
    'mouseenter',
    'unmouseenter',
    'mousemove',
    'unmousemove',
    'mouseout',
    'mouseup',
    'unmouseup',
    'mousedown',
    'unpick',
];
export const OriginLayerEventList = [
    // 图层事件
    // 代理掉的事件 'inited', 'add', 'remove',
    'show',
    'hide',
    'dataUpdate',
    'destroy',
    // 数据映射更新，图例更新事件
    'legend',
    'legend:color',
    'legend:size',
    ...OriginMouseLayerEventList,
];
export var CoreLayerEvent;
(function (CoreLayerEvent) {
    CoreLayerEvent["CREATED"] = "created";
    CoreLayerEvent["INITED"] = "inited";
    CoreLayerEvent["ADD"] = "add";
    CoreLayerEvent["REMOVE"] = "remove";
})(CoreLayerEvent || (CoreLayerEvent = {}));
export var CompositeLayerEvent;
(function (CompositeLayerEvent) {
    CompositeLayerEvent["CREATED"] = "created";
    CompositeLayerEvent["INITED"] = "inited";
    CompositeLayerEvent["ADD"] = "add";
    CompositeLayerEvent["REMOVE"] = "remove";
})(CompositeLayerEvent || (CompositeLayerEvent = {}));
export var LayerGroupEvent;
(function (LayerGroupEvent) {
    LayerGroupEvent["INITED_LAYER"] = "inited-layer";
    LayerGroupEvent["INITED_LAYERS"] = "inited-layers";
})(LayerGroupEvent || (LayerGroupEvent = {}));
//# sourceMappingURL=constants.js.map